export const CATEGORIE_CANDIDATURA = [
  'Prodotti da forno',
  'Conserve',
  'Prodotti caseari',
  'Logistica',
  'Altro',
];

export function validaBozzaMinima(dati) {
  const errori = [];

  if (!dati.categoria) {
    errori.push('Seleziona una categoria di candidatura');
  }

  if (!dati.datiFornitore?.ragioneSociale?.trim()) {
    errori.push('Ragione Sociale è obbligatoria');
  }

  const referenti = dati.datiFornitore?.referenti || [];
  if (referenti.length === 0) {
    errori.push('Aggiungi almeno un referente');
  } else {
    referenti.forEach((ref, index) => {
      const hasEmail = (ref.recapiti || []).some(
        (recapito) =>
          (recapito.tipo === 'email' || recapito.tipo === 'pec') &&
          recapito.contatto?.trim()
      );
      if (!hasEmail) {
        errori.push(
          `Il referente ${index + 1} deve avere almeno un'email o PEC per ricevere il codice di accesso`
        );
      }
    });
  }

  return { valida: errori.length === 0, errori };
}

export function validaCandidatura(dati) {
  const errori = [];

  if (!dati.categoria) {
    errori.push('Seleziona una categoria di candidatura');
  }

  if (!dati.datiFornitore?.ragioneSociale?.trim()) {
    errori.push('Ragione Sociale è obbligatoria');
  }

  (dati.datiFornitore?.referenti || []).forEach((ref, index) => {
    if (!ref.nome?.trim()) {
      errori.push(`Nome del referente ${index + 1} è obbligatorio`);
    }
    if (!ref.cognome?.trim()) {
      errori.push(`Cognome del referente ${index + 1} è obbligatorio`);
    }

    const hasEmail = (ref.recapiti || []).some(
      (recapito) =>
        (recapito.tipo === 'email' || recapito.tipo === 'pec') &&
        recapito.contatto?.trim()
    );

    if (!hasEmail) {
      errori.push(
        `Il referente ${index + 1} (${ref.nome || ''} ${ref.cognome || ''}) deve avere almeno un'email o PEC per ricevere il codice di accesso`
      );
    }
  });

  if (dati.categoria !== 'Logistica' && (dati.prodotti || []).length === 0) {
    errori.push('Aggiungi almeno un prodotto');
  }

  if (dati.categoria !== 'Logistica') {
    (dati.prodotti || []).forEach((p, i) => {
      const n = i + 1;
      if (!p.nome?.trim()) errori.push(`Prodotto ${n}: nome obbligatorio`);
      if (!p.costoProduzione) errori.push(`Prodotto ${n}: costo di produzione obbligatorio`);
      if (!p.produzioneGiornaliera) errori.push(`Prodotto ${n}: produzione giornaliera obbligatoria`);
      if (p.tempoPreavviso === '' || p.tempoPreavviso === undefined || p.tempoPreavviso === null) {
        errori.push(`Prodotto ${n}: tempo di preavviso obbligatorio`);
      }
      if (!p.ore_max_trasporto) errori.push(`Prodotto ${n}: ore max trasporto obbligatorie`);
      if (!p.tipo_spedizione) errori.push(`Prodotto ${n}: tipo spedizione obbligatorio`);
    });
  }

  return { valida: errori.length === 0, errori };
}

export function calcolaProgressoCandidatura(dati) {
  let filled = 0;
  const total = 5;

  if (dati.categoria) filled += 1;
  if (dati.datiFornitore?.ragioneSociale?.trim()) filled += 1;

  const hasReferenteEmail = (dati.datiFornitore?.referenti || []).some((ref) =>
    (ref.recapiti || []).some(
      (r) => (r.tipo === 'email' || r.tipo === 'pec') && r.contatto?.trim()
    )
  );
  if (hasReferenteEmail) filled += 1;

  if (dati.categoria === 'Logistica' || (dati.prodotti || []).some((p) => p.nome?.trim())) {
    filled += 1;
  }

  if ((dati.documenti || []).some((d) => d.titolo || d.file) || dadosHasMessaggio(dati)) {
    filled += 1;
  }

  return Math.round((filled / total) * 100);
}

function dadosHasMessaggio(dati) {
  return Boolean(dati.messaggio_candidatura?.trim?.() || dati.messaggioCandidatura?.trim?.());
}
